import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { LoginFormComponent, ResetPasswordFormComponent } from './components';

import { SideNavOuterToolbarComponent, UnauthenticatedContentComponent } from './layouts';

import { CrmContactListComponent } from './pages/crm-contact-list/crm-contact-list.component';
import { CrmContactDetailsComponent } from './pages/crm-contact-details/crm-contact-details.component';
import { PlanningTaskListComponent } from './pages/planning-task-list/planning-task-list.component';
import { PlanningTaskDetailsComponent } from './pages/planning-task-details/planning-task-details.component';
import { AnalyticsDashboardComponent } from './pages/analytics-dashboard/analytics-dashboard.component';
import { AnalyticsSalesReportComponent } from './pages/analytics-sales-report/analytics-sales-report.component';
import { AnalyticsGeographyComponent } from './pages/analytics-geography/analytics-geography.component';
import { PlanningSchedulerComponent } from './pages/planning-scheduler/planning-scheduler.component';
import { AppSignInComponent } from './pages/sign-in-form/sign-in-form.component';
import { AppResetPasswordComponent } from './pages/reset-password-form/reset-password-form.component';
import { UserProfileComponent } from './pages/user-profile/user-profile.component';
import { ThankYouComponent } from './thank-you/thank-you.component';
import { SatReferralComponent } from './mdoc/sat-referral/sat-referral.component';
import { SatReferralListComponent } from './mdoc/sat-referral-list.component';
import { UserListComponent } from './admin/user-list.component';
import { UserDetailComponent } from './admin/user-detail.component';
import { EventLogComponent } from './admin/event-log.component';
import { AuthGuardService } from './services/auth-guard.service';
import { HomeComponent } from './home.component';

const routes: Routes = [
  {
    path: 'auth',
    component: UnauthenticatedContentComponent,
    children: [
      {
        path: 'login',
        component: LoginFormComponent
      },
      {
        path: 'reset-password',
        component: ResetPasswordFormComponent,
        canActivate: [AuthGuardService]
      },
      {
        path: '**',
        redirectTo: 'login',
        pathMatch: 'full'
      }
    ]
  },
  {
    path: '',
    component: SideNavOuterToolbarComponent,
    canActivate: [AuthGuardService],
    children: [
      {
        path: 'home',
        component: HomeComponent
      },
      {
        path: 'mdoc/sat-referral',
        component: SatReferralListComponent,
        canActivate: [AuthGuardService],
        data: { roles: ['Administrator'] }
      },
      {
        path: 'mdoc/sat-referral/create',
        component: SatReferralComponent,
        canActivate: [AuthGuardService]
      },
      {
        path: 'mdoc/sat-referral/:id',
        component: SatReferralComponent,
        canActivate: [AuthGuardService],
        data: { roles: ['Administrator'] }
      },
      {
        path: 'admin/users',
        component: UserListComponent,
        canActivate: [AuthGuardService],
        data: { roles: ['Administrator'] }
      },
      {
        path: 'admin/users/create',
        component: UserDetailComponent,
        canActivate: [AuthGuardService],
        data: { roles: ['Administrator'] }
      },
      {
        path: 'admin/users/:id',
        component: UserDetailComponent,
        data: { roles: ['Administrator'] }
      },
      {
        path: 'admin/event-log',
        component: EventLogComponent
      },
      {
        path: 'crm-contact-list',
        component: CrmContactListComponent,
        canActivate: [AuthGuardService]
      },
      {
        path: 'crm-contact-details',
        component: CrmContactDetailsComponent,
        canActivate: [AuthGuardService]
      },
      {
        path: 'planning-task-list',
        component: PlanningTaskListComponent,
        canActivate: [AuthGuardService]
      },
      {
        path: 'planning-task-details',
        component: PlanningTaskDetailsComponent
      },
      {
        path: 'planning-scheduler',
        component: PlanningSchedulerComponent
      },
      {
        path: 'analytics-dashboard',
        component: AnalyticsDashboardComponent,
        canActivate: [AuthGuardService]
      },
      {
        path: 'analytics-sales-report',
        component: AnalyticsSalesReportComponent,
        canActivate: [AuthGuardService]
      },
      {
        path: 'analytics-geography',
        component: AnalyticsGeographyComponent,
        canActivate: [AuthGuardService]
      },
      {
        path: 'sign-in-form',
        component: AppSignInComponent,
        canActivate: [AuthGuardService]
      },
      {
        path: 'reset-password-form',
        component: AppResetPasswordComponent,
        canActivate: [AuthGuardService]
      },
      {
        path: 'user-profile',
        component: UserProfileComponent
      },
      {
        path: 'thank-you',
        component: ThankYouComponent
      },
      {
        path: '**',
        redirectTo: '/home',
        pathMatch: 'full'
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false }), BrowserModule],
  providers: [AuthGuardService],
  exports: [RouterModule],
  declarations: []
})
export class AppRoutingModule {}
